import React, { useContext, useEffect, useState } from "react";
import { ReactSortable } from "react-sortablejs";
import Popup from "./Popup";
import { Link, useNavigate } from "react-router-dom";
import "../sass/CustomiseData.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFloppyDisk } from "@fortawesome/free-solid-svg-icons";
import { ChoosenDataSet } from "./context/ChoosenDataSet";
import { NewAddDomain } from "./context/NewAddDomain";
import { CityContext } from "./context/CityContext";
import { isMobile } from "react-device-detect";
import { ContentContext } from "./context/ContentContext";
import { LayerContext } from "./context/LayerContext";
import { SelectedDataSet } from "./context/SelectedDataset";
import { toast, ToastContainer } from "react-toastify";
import ConnectNowInterface from "../components/ConnectNowInterface";
const AllAvailableData = () => {
  const { cityData } = useContext(ContentContext);
  const [state, setState] = useState();
  const cityLocal = JSON.parse(localStorage.getItem("city"))
  const { city } = useContext(CityContext);
  // console.log(cityData);
  // console.log(cityLocal);
  // console.log(Object.keys(cityLocal.dataList)[0]);
  useEffect(() => {
    // console.log("in")
    if (cityData) {
      setState(Object.keys(cityData.dataList[Object.keys(cityData.dataList)[0]]));
    }
    else {
      setState(Object.keys(cityLocal.dataList[Object.keys(cityLocal.dataList)[0]]))
      
    }
  }, [cityData, city])
  
  return (
  <div>
      {!isMobile && state != undefined ? <ReactSortable style={{ border: "1px solid gold", borderRadius: "10px" }}
        tag="div" list={state && state} setList={(e) => {
      if (cityData) {
        setState(Object.keys(cityData.dataList[Object.keys(cityLocal.dataList)[0]]))
      }
      else {
        setState(Object.keys(cityLocal.dataList[Object.keys(cityLocal.dataList)[0]]))
      }
    }} group="groupName">
      { state!=undefined && state.map((item, id) => (
        <button className={`${item=="Satellite True Color (10m)" || item=="Satellite False Color (10m)" ?"customized-btn-diff":"customized-btn"}`} key={id}>{item}</button>
      ))}
      </ReactSortable> : isMobile && state != undefined && <ReactSortable
    style={{border:"1px solid gold",borderRadius:"10px"}}    tag="div" list={state && state} setList={(e) => {
      if (cityData) {
        setState(Object.keys(cityData.dataList[Object.keys(cityLocal.dataList)[0]]))
      }
      else {
        setState(Object.keys(cityLocal.dataList[Object.keys(cityLocal.dataList)[0]]))
      }
    }} group="groupName">
      { state!=undefined && state.map((item, id) => (
        <button className={`${item=="Satellite True Color (10m)" || item=="Satellite False Color (10m)" ?"customized-btn-mob-diff":"customized-btn-mob"}`} key={id}>{item}</button>
      ))}
    </ReactSortable> }
    </div>
  );
};

const ChoosenData = ({notify,getDomain}) => {
  const datasets=JSON.parse(localStorage.getItem("dataset"))
  const navigate = useNavigate();
  const { newAdd } = useContext(NewAddDomain);
  const { newAddDataSet } = useContext(NewAddDomain);
  const { choosenData } = useContext(ChoosenDataSet);
  const { city } = useContext(CityContext);
  const [state, setState] = useState([]);
  const { getLayer } = useContext(LayerContext);
  const { getSelectedIdx } = useContext(SelectedDataSet);
  const { getChoosenData } = useContext(ChoosenDataSet);
  const {getSelectedDataSet}=useContext(SelectedDataSet);
  let [newDataDomain,setNewDataDomain]=useState()
  useEffect(() => {
    let arr = [];
    if (newAddDataSet == undefined) {
      // console.log(datasets);
      for (let i = 0; i < datasets.length; i++) {
        arr.push(datasets[i].name);
      }
    }
    else {
      for (let i = 0; i < newAddDataSet.length; i++) {
        arr.push(newAddDataSet[i].name);
      }
    }
    setState(arr);
  }, [])
  
  // console.log(newAddDataSet);
  // console.log(state);
  const addNewDataSet = (e) => {
    // console.log(e)
    let a = (e.toString().split(","));
    let b = (state.toString().split(","));
    let check = true;
    // console.log(a);
    // console.log(b);
    for (let i = 0; i < a.length; i++){
      let present = false;
      for (let j = 0; j < b.length; j++){
        if (a[i] == b[j]) {
          present = true;
          break;
        }
      }
      if (present == false) {
        check = false;
        break;
      }
    }
    let arr=[]
    let temp = (e.toString().split(","));
    // console.log(temp);
    for (let i = 0; i < temp.length; i++){
      arr.push({name:temp[i],url:temp[i]})
    }
    if (check == false) {
      if (state.length >= 10) {
        notify(true);
      }
      else {
        setNewDataDomain(arr);
        getDomain(arr)
        // newAdd(arr);
        setState(e)
      }
      
    }
    else if(check==true && arr.length<state.length) {
      // console.log(arr);
      setState(e);
      setNewDataDomain(arr);
      getDomain(arr)
      // newAdd(arr);
    }
  }
  // console.log(state);
  return (
    <div>
      {state != undefined && !isMobile ?
        <div ><ReactSortable style={{border:"1px solid gold",borderRadius:"10px",marginBottom:"50px"}} tag="div" list={state != undefined && state} setList={(e) => {
      // let a=(e[e.length - 1].toString());
      // let b=(state.toString());
      // let check = b.includes(a);
      
      if (e.length > 0) {
        addNewDataSet(e)
      }
      
      
    }} group = "groupName" >
          {state && state.map((item, id) => (
              <button className={`${item=="Satellite True Color (10m)" || item=="Satellite False Color (10m)" ?"customized-btn-diff":"customized-btn"}`}  key={id}>{item}</button>
        ))}
        </ReactSortable>
      </div>  : state != undefined && isMobile &&
        <div>
             
    <ReactSortable style={{border:"1px solid gold",marginBottom:"10px",borderRadius:"10px"}} tag="div" list={state!=undefined && state} setList={(e) => {
      // let a=(e[e.length - 1].toString());
      // let b=(state.toString());
      // let check = b.includes(a);
      
      if (e.length > 0) {
        addNewDataSet(e)
      }
    }} group = "groupName" >
        {state && state.map((item, id) => (
        <button className={`${item=="Satellite True Color (10m)" || item=="Satellite False Color (10m)" ?"customized-btn-mob-diff":"customized-btn-mob"}`} key={id}>{item}</button>
        ))}
      <div className="ListFooter">
        
          </div>
            </ReactSortable>
            {/* <div style={{marginTop:"30px"}}>
              <Link onClick={() => {
              // console.log(newDataDomain);
              // newAdd();
              // getChoosenData(choosenData);
              getLayer(false);
              getSelectedIdx([]);
              getSelectedDataSet();
                localStorage.removeItem("dataset")
            }}  className="btn btn-link" to={"/"}>
              Cancel
            </Link>
        <button onClick={() => {
          // console.log(newDataDomain)
          newAdd(newDataDomain)
              navigate("/");
              getLayer(false);
              getSelectedIdx([]);
              getSelectedDataSet();
          localStorage.removeItem("dataset")
            }} className="btn btn-primary">
              <FontAwesomeIcon icon={faFloppyDisk} size="lg" /> Save
            </button>
            </div> */}
           
    </div>}
    </div>
  );
};
const CustomiseData = (props) => {
  const [open, setOpen] = useState(false);
  const [newAdddomain, setNewAddDomain] = useState();
  const datasets=JSON.parse(localStorage.getItem("dataset"))
  const navigate = useNavigate();
  const { newAdd } = useContext(NewAddDomain);
  const { newAddDataSet } = useContext(NewAddDomain);
  const { choosenData } = useContext(ChoosenDataSet);
  const { city } = useContext(CityContext);
  const [state, setState] = useState([]);
  const { getLayer } = useContext(LayerContext);
  const { getSelectedIdx } = useContext(SelectedDataSet);
  const { getChoosenData } = useContext(ChoosenDataSet);
  const {getSelectedDataSet}=useContext(SelectedDataSet);
  const newDomains = (data) => {
    setNewAddDomain(data);
  }
  // const notify = (data) => {
  //   setOpen(data);
  // }
  const notify = () => toast.error('You can not add more than 10 datasets at once', {
        position: "bottom-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme:"dark",
  });
  const openOrNot = (data) => {
    setOpen(true)
  }
  useEffect(() => {
    if (open == true) {
      notify()
    }
    setOpen(false)
  },[open])
  return (
    <Popup >
      <div className={`${!isMobile ? "ListWrapperWeb" : "ListWrapperMob"}`}>
        {isMobile && <div style={{
          marginTop:"-2%"
        }}>
            <ConnectNowInterface/>
          </div>}
        <div className="ListSelectedContainer">
          <p>Insights Currently Selected</p>
          <ChoosenData getDomain={newDomains} notify={openOrNot} />
          {open==true && <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
          />}
          
        </div>
        <div className="ListAvailContainer">
          <p>All Available Datasets</p>
          <AllAvailableData />
          <div className="ListFooter">
        <Link onClick={() => {
              // console.log(newDataDomain);
              // newAdd();
              // getChoosenData(choosenData);
              getLayer(false);
              getSelectedIdx([]);
              getSelectedDataSet();
                // localStorage.removeItem("dataset")
                  }}  className="btn btn-link" to={"/"}>
                    Cancel
                  </Link>
              <button onClick={() => {
                // console.log(newDataDomain)
                newAdd(newAdddomain)
              navigate("/");
              getLayer(false);
              getSelectedIdx([]);
              getSelectedDataSet();
          // localStorage.removeItem("dataset")
            }} className="btn btn-primary">
              <FontAwesomeIcon icon={faFloppyDisk} size="lg" /> Save
            </button>
          </div>
        </div>
        {!isMobile && <div style={{
          marginTop:"-2%"
        }}>
            <ConnectNowInterface/>
          </div>}
        
      </div>
    </Popup>
  );
};

export default CustomiseData;
